import * as React from 'react';
import { connect } from 'react-redux';
import * as Components from '../../../components/index';
import * as Models from '../../../models/index';
import * as ActionCreators from '../../../actions/action.creators';

interface StateProps {
	questions: Models.Question[];
	allowReset: boolean;
	answers: { [id: string]: Models.Answer };
	processing: boolean;
}
interface DispatchProps {
	goToNext(): any;
	updateAnswer(answer: string, questionId: string): any;
	sendAnswers(): any;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	questions: state.pwdRecovery.questions,
	allowReset: state.pwdRecovery.allowReset,
	answers: state.pwdRecovery.answers,
	processing: state.shell.processing,
});
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
	goToNext: () => dispatch(ActionCreators.PwdRecovery.checkAnswers()),
	updateAnswer: (answer: string, questionId: string) => dispatch(ActionCreators.PwdRecovery.changeAnswer(answer, questionId)),
	sendAnswers: () => dispatch(ActionCreators.PwdRecovery.checkAnswers()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	class Component extends React.Component<StateProps & DispatchProps, { questions: any[] }> {
		render() {
			return (
				<Components.LayoutBlock fill>
					<Components.LayoutBlock fill className='recovery-phase' align='center'>
						<Components.LayoutBlock inline={true} verticalAlign='center' className='inform-section'>
							<Components.Icon icon='question' size='4' />
							<Components.Label className='recovery-label'>Please answer the questions</Components.Label>
						</Components.LayoutBlock>
						<Components.LayoutBlock className='questions' style={{ minWidth: 600 }}>
							{this.props.questions.map((q, index) => {
								var answer = this.props.answers[q.questionId];
								return (
									<Components.LayoutBlock key={index} verticalAlign='center' className='recovery-question'>
										<Components.Label>{index + 1 + ') ' + q.questionText}</Components.Label>
										<Components.Textbox
											placeholder='Answer'
											value={answer.answer}
											type='password'
											onChange={(value: string) => {
												this.props.updateAnswer(value, q.questionId);
											}}
										/>
									</Components.LayoutBlock>
								);
							})}
						</Components.LayoutBlock>
					</Components.LayoutBlock>
					<Components.LayoutBlock>
						<Components.Button busy={this.props.processing} onClick={this.props.sendAnswers.bind(this)}>
							Next
						</Components.Button>
						<Components.Button onClick={() => (window.location.hash = '/')}>To Login</Components.Button>
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
